'use client';

import { SessionProvider } from 'next-auth/react';
import { ReactNode } from 'react';
import { useNavigationForApi } from '@/src/hooks/use-navigation-for-api';
import { Toaster } from 'sonner';
import { LoadingBarProvider } from './loading-bar-context';
import { UpgradeModalProvider } from './upgrade-modal-provider';

// Client component that wraps the NavigationProvider
function NavigationProvider({ children }: { children: ReactNode }) {
  // Set up navigation for API client
  useNavigationForApi();
  return <>{children}</>;
}

export function Providers({
  children,
  session
}: {
  children: ReactNode;
  session: any;
}) {
  return (
    <SessionProvider session={session}>
      <NavigationProvider>
        <UpgradeModalProvider>
          <LoadingBarProvider>
            {children}
            <Toaster position='top-right' />
          </LoadingBarProvider>
        </UpgradeModalProvider>
      </NavigationProvider>
    </SessionProvider>
  );
}
